import { render, staticRenderFns } from "./MenuItemIngredients.vue?vue&type=template&id=4913c364"
import script from "./MenuItemIngredients.vue?vue&type=script&lang=js"
export * from "./MenuItemIngredients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports